"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unilib_error_1 = __importDefault(require("unilib-error"));
class URegistry {
    constructor() {
        this.__ = {};
    }
    set(key, value) {
        if (typeof key !== 'string' || key.trim() === '') {
            throw new unilib_error_1.default(`${this.constructor.name}.set/INVALID_KEY`, {
                context: { key }
            });
        }
        if (value === undefined || value === null) {
            throw new unilib_error_1.default(`${this.constructor.name}.set/INVALID_VALUE`, {
                context: { value }
            });
        }
        this.__[key] = { value };
    }
    register(key, initializer) {
        if (typeof key !== 'string' || key.trim() === '') {
            throw new unilib_error_1.default(`${this.constructor.name}.register/INVALID_KEY`, {
                context: { key }
            });
        }
        if (typeof initializer !== 'function') {
            throw new unilib_error_1.default(`${this.constructor.name}.register/INVALID_VALUE_INITIALIZER`, { context: { initializer } });
        }
        this.__[key] = { initializer, value: 0 };
    }
    isRegistered(key) {
        return typeof key === 'string' ? Boolean(this.__[key]) : false;
    }
    get(key, defaultValue) {
        try {
            if (typeof key !== 'string' || key.trim() === '') {
                throw new unilib_error_1.default(`${this.constructor.name}.get/INVALID_KEY`, {
                    context: { key }
                });
            }
            if (!this.isRegistered(key)) {
                if (defaultValue !== undefined && defaultValue !== null) {
                    return defaultValue;
                }
                throw new unilib_error_1.default(`${this.constructor.name}.get/UNREGISTERED_KEY`, {
                    context: { key }
                });
            }
            const entry = this.__[key];
            if (entry.initializer) {
                const value = entry.initializer(this);
                if (value === undefined || value === null) {
                    throw new unilib_error_1.default(`${this.constructor.name}.get/INVALID_VALUE_INITIALIZED`);
                }
                delete entry.initializer;
                entry.value = value;
            }
            return entry.value;
        }
        catch (error) {
            if (error.message.startsWith(`${this.constructor.name}.get`))
                throw error;
            throw new unilib_error_1.default(`${this.constructor.name}.get/UNEXPECTED`, {
                cause: error
            });
        }
    }
}
exports.URegistry = URegistry;
exports.default = URegistry;
